import fetch from './fetch'
const client = fetch()

export const paths = {
  projects: '/projects'
}

type ExternalProjectPlatform = 'teamwork'
export interface ProjectReq {
  clientId: number
  title: string
  description: string
  externalProjectId?: string
  externalProjectPlatform?: ExternalProjectPlatform
  tags?: string[]
  isInternal?: boolean
}

export interface Resource {
  id: string
  title: string
  url: string
  platform: 'google_docs' | 'slack' | 'other'
}

export interface ProjectResp {
  clientId: number
  id: number
  title: string
  description: string
  status: 'active' | 'deleted'
  tags?: string[]
  resources?: Resource[]
  externalProjectId?: string
  externalProjectPlatform?: ExternalProjectPlatform
  createdAt: string
  updatedAt: string
  createdBy: number
  updatedBy: number
  isInternal: boolean
  attaboyProjectId?: string
}

export type Platform = 'google_docs' | 'slack' | 'other' | 'google_slides'
export interface ResourceReq {
  clientId: number
  title: string
  url: string
  platform: Platform
}

export interface ResourceResp {
  id: string
  title: string
  url: string
  platform: Platform
  createdBy: number
  createdAt: string
}

export const createProject = async (data: ProjectReq): Promise<ProjectResp> => {
  const path = paths.projects
  return await client.post<ProjectResp>({ path, data })
}

export const getProjects = async (clientId: number): Promise<ProjectResp[]> => {
  const path = `${paths.projects}?client_id=${clientId}`
  return await client.get<ProjectResp[]>({ path })
}

export const getProject = async (clientId: number, projectId: string): Promise<ProjectResp> => {
  const path = `${paths.projects}/${projectId}?client_id=${clientId}`
  return await client.get<ProjectResp>({ path })
}

export const updateProject = async (clientId: number, projectId: string, data: ProjectReq): Promise<ProjectResp> => {
  const path = `${paths.projects}/${projectId}?client_id=${clientId}`
  return await client.patch<ProjectResp>({ path, data })
}

export const deleteProject = async (clientId: number, projectId: number): Promise<ProjectResp> => {
  const path = `${paths.projects}/${projectId}?client_id=${clientId}`
  return await client.del<ProjectResp>({ path })
}

export const createResource = async (projectId: string, data: ResourceReq): Promise<ResourceResp> => {
  const path = `${paths.projects}/${projectId}/resources`
  return await client.post<ResourceResp>({ path, data })
}

export const getResources = async (projectId: string, clientId: number): Promise<ResourceResp[]> => {
  const path = `${paths.projects}/${projectId}/resources?client_id=${clientId}`
  return await client.get<ResourceResp[]>({ path })
}

export const deleteResource = async (projectId: string, resourceId: string, clientId: number): Promise<void> => {
  const path = `${paths.projects}/${projectId}/resources/${resourceId}?client_id=${clientId}`
  await client.del({ path })
}
